import {EditUserDocument, EditUserInput} from "generated/graphql";
import {useMutation} from "@apollo/client";
import {setToken} from "utilities/auth";

export const useEditUser = () => {
  const [mutate] = useMutation(EditUserDocument);

  return async (input: EditUserInput) => {
    const res = await mutate({ variables: { input } });
    if (res.data?.editUser.token) {
      setToken(res.data?.editUser.token);
    }
  }
}